export default __webpack_public_path__ + "static/media/hug-world.75fae31f.png";